import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function KnowledgeIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path d="M28 58V122C46 116 66 116 80 126C94 116 114 116 132 122V58Z" fill={c.p500} />
      <path
        d="M80 58C66 50 48 50 34 56V112C48 106 66 106 80 114Z"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <path
        d="M80 58C94 50 112 50 126 56V112C112 106 94 106 80 114Z"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <path
        d="M46 70q12-3 24 2M46 82q12-3 24 2M46 94q12-3 24 2M114 70q-12-3-24 2M114 82q-12-3-24 2M114 94q-12-3-24 2"
        stroke={c.p200}
        strokeWidth="3"
      />
      <path d="M80 14Q82 26 94 28Q82 30 80 42Q78 30 66 28Q78 26 80 14Z" fill={c.a400} />
    </Frame>
  );
}
